import { lazy } from 'react'

export default {
    path: '/report/stato-odl',
    title: 'Stato ODL',
    authenticated: true,
    component: lazy(() => import('./filter'))
}